module.exports = __webpack_public_path__ + "img/Bag-Multiply.b9b29748.svg";